import { useCallback } from 'react';

import { Coordinates } from '../typings/main';

export const useGeocoding = () => {
  const geocodeZipCode = useCallback(async (zipCode: string): Promise<Coordinates | null> => {
    if (!window.google || !window.google.maps) return null;

    const isValidUSZip = /^\d{5}$/.test(zipCode);
    const isValidCAPostalCode = /^[A-Za-z]\d[A-Za-z][\s-]?\d[A-Za-z]\d$/.test(zipCode);

    if (!isValidUSZip && !isValidCAPostalCode) {
      console.warn('⚠️ Cannot geocode invalid ZIP/postal code:', zipCode);
      return null;
    }

    return new Promise((resolve) => {
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address: zipCode }, (results, status) => {
        if (status === 'OK' && results && results[0]) {
          const location = results[0].geometry.location;
          resolve({
            lat: location.lat(),
            lng: location.lng()
          });
        } else {
          console.error('Geocode was not successful:', status);
          resolve(null);
        }
      });
    });
  }, []);

  const getZipFromCoordinates = useCallback(async (lat: number, lng: number): Promise<string | null> => {
    if (!window.google || !window.google.maps) return null;

    return new Promise((resolve) => {
      const geocoder = new google.maps.Geocoder();
      const latlng = { lat, lng };

      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK' && results && results[0]) {
          const addressComponents = results[0].address_components || [];

          const zipComponent = addressComponents.find((component) =>
            component.types.includes('postal_code')
          );

          resolve(zipComponent?.long_name || null);
        } else {
          console.error('Reverse geocode failed:', status);
          resolve(null);
        }
      });
    });
  }, []);

  return {
    geocodeZipCode,
    getZipFromCoordinates
  };
};